const state = {
  initialPositions: ''
}

const mutations = {
  'SET_VISMEMPOSITIONS' (state, pos) {
    state.initialPositions = pos
  }
}

const actions = {
  changeVismemPositions: ({commit}, pos) => {
    commit('SET_VISMEMPOSITIONS', pos)
  }
}

const getters = {
  currentVismemPositions: state => {
    return state.initialPositions
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/vismem.js